import { ContactInformation as ContactInformationProto } from '@taxfyle/api-internal/shared/types/contact_info_pb'
import type { ContactInfo } from './ContactInfo'
import { PhysicalAddress } from './PhysicalAddress'
import {
  mapPhysicalAddressProtoToProps,
  mapPhysicalAddressToProto,
} from './physical-address-mappers'

export function mapContactInfoProtoToProps(
  proto: ContactInformationProto,
): ContactInfo {
  const addressProto = proto.getAddress()
  return {
    email: proto.getEmail(),
    phoneNumber: proto.getPhoneNumber(),
    physicalAddress: addressProto
      ? mapPhysicalAddressProtoToProps(addressProto)
      : PhysicalAddress.empty,
  }
}

export function mapContactInfoToProto(
  contactInfo: ContactInfo,
): ContactInformationProto {
  return new ContactInformationProto()
    .setEmail(contactInfo.email)
    .setPhoneNumber(contactInfo.phoneNumber)
    .setAddress(mapPhysicalAddressToProto(contactInfo.physicalAddress))
}
